module.exports = __webpack_public_path__ + "files/2096b3f43b8d8f89c5615402675e2866.png";